import React from 'react'
import { ListSubheader, MenuItem } from '@mui/material'
import type { Transform } from '../../../types/adaptations'

/** MUI Select requires these elements as direct children, so return a flat array. */
export const impactFunctionOptions = (transforms: Transform[]) => {
  const platform = transforms.filter(transform => transform.organisation_id == null)
  const organisation = transforms.filter(transform => transform.organisation_id != null)

  return [
    ...(organisation.length > 0
      ? [
          <ListSubheader key="organisation-functions" disableSticky>
            Your organisation
          </ListSubheader>,
        ]
      : []),
    ...organisation.map(transform => (
      <MenuItem key={transform.id} value={transform.id}>
        {transform.label}
      </MenuItem>
    )),
    ...(platform.length > 0
      ? [
          <ListSubheader key="platform-functions" disableSticky>
            Platform defaults
          </ListSubheader>,
        ]
      : []),
    ...platform.map(transform => (
      <MenuItem key={transform.id} value={transform.id}>
        {transform.label}
      </MenuItem>
    )),
  ]
}
